module.exports = __webpack_public_path__ + "a5f66a56a2cd012c74b4bd96d1d87fd4.jpg";